import { Component, EventEmitter, OnInit, Output, QueryList, Renderer2, ViewChildren } from '@angular/core';
import { AgGridI, PaginationModel } from '../../../../shared/common-components/ag-grid/ag-grid.model';
import { CommonFilterService } from '../../../../shared/services/common-filter.service';
import { DateRangeType, StorageName } from '../../../../shared/enum/common-enum';
import { SendDataService } from '../../../../shared/services/send-data.service';
import { AgGridDataModelLayawaysReport } from './layaways-report.model';
import { AgGridComponent } from '../../../../shared/common-components/ag-grid/ag-grid.component';
import { StorageService } from '../../../../shared/services/storage.service';
import { InvestmentFundService } from '../investment-fund.services';
import { CommonService } from '../../../../shared/services/common.service';
import { NotificationService } from '../../../../shared/services/notification.service';
import { LayawaysReportAdvancedFilterPopupComponent } from './advanced-filter-popup/advanced-filter-popup.component';
import { Router } from '@angular/router';
import { VoucherType, VoucherTypeName } from '../../../../shared/models/common.model';
import { FileReaderService } from '../../../../shared/services/file.reader.service';
import { InvestmentFundTabs } from '../investment-fund.component';

@Component({
  selector: 'app-layaways-report',
  templateUrl: './layaways-report.component.html',
  styleUrls: ['./layaways-report.component.scss']
})
export class LayawaysReportComponent extends CommonService implements OnInit {
  agGridDataModel: AgGridI;
  gridApi: any;
  apiRequestModel: any = {};
  filterCountValue: any = 2;
  pagination = new PaginationModel();
  @ViewChildren(AgGridComponent) grids: QueryList<AgGridComponent>;
  apiRequestStorageName = StorageName.APIREQUEST_TRANSACTION_LAYAWAYS_REPORT_GRID;
  formName = StorageName.FORMNAME_TRANSACTION_LAYAWAYS_REPORT;
  getAllDropdownModel: any = {};
  @Output() changeTabEvent = new EventEmitter();
  constructor(
    public commonFilterService: CommonFilterService,
    private sendDataService: SendDataService,
    public storageService: StorageService,
    public investmentFundService: InvestmentFundService,
    public renderer: Renderer2,
    public notificationService: NotificationService,
    private router               : Router,
     public fileReaderService     : FileReaderService,
  ) { super(renderer) }

  ngOnInit(): void {
    this.sendDataService.displayPageName(this.formName);
    this.agGridDataModel = AgGridDataModelLayawaysReport;

  }
  onGridReady(event) {
    this.gridApi = event;
    this.setDefaultFilter();
  }

  setDefaultFilter() {
    this.apiRequestModel.filters = '';
    this.filterCountValue = 2;
    this.commonFilterService.setDefaultFilter(this.apiRequestStorageName, this.apiRequestModel, this.agGridDataModel?.filterStorageName, { setDefaultDateRangePickerData: { dateRangeType: DateRangeType.FinancialYear, columnData: ['fromJoiningDate,toJoiningDate'] } });
    this.getAllLayawaysReportList();
  }

  getAllLayawaysReportList() {
    this.showLoading(this.gridApi);
    this.apiRequestModel = this.storageService.retrieve(this.apiRequestStorageName);
    this.investmentFundService.getAllLayawaysReport(this.apiRequestModel).subscribe({
      next: (res) => {
        this.commonFilterService.processServersideApiResponse(res, this.grids?.first, this.gridApi, this.pagination, this.apiRequestModel?.getAll);
      },
      error: (err) => {
        this.hideLoading(this.gridApi);
        this.gridApi?.api?.setRowData([]);
      }
    });
  }

  onSortIconClick(event) {
    this.commonFilterService.storeChangedSortList(this.agGridDataModel?.sortStorageName, this.apiRequestStorageName);
    this.getAllLayawaysReportList();
  }

  handleTextClick(event) {
    if (event?.data?.againstVoucherTypeId == VoucherType.SalesInvoice && event?.colDef?.field == 'againstInvoiceNo') {
      this.storageService.store("SaleInvoiceId", event?.data?.againstVoucherNo);
      this.router.navigate(['transaction/saleinvoice']);
    } else if (event?.data?.againstVoucherTypeId == VoucherType.SalesQuotation && event?.colDef?.field == 'againstInvoiceNo') {
      this.storageService.store(StorageName.STORED_TRANSACTION_SALESQUOTATION_ID, event?.data?.againstVoucherNo);
      this.router.navigate(['transaction/estimate']);
    } else if (event?.data?.voucherTypeId == VoucherType.InvestmentFund && event?.colDef?.field == 'invoiceNo') {
      this.storageService.store("InvestmentFundInvoiceId", event?.data?.againstVoucherNo);
      this.changeTabEvent?.emit(event?.data);
    }
  }

  onPagination(pagination: PaginationModel) {
    this.storeChangedPagination(pagination);
    this.getAllLayawaysReportList();
  }

  storeChangedPagination(paginationModel: PaginationModel) {
    this.pagination = this.commonFilterService.storeChangedPagination(paginationModel, this.pagination, this.agGridDataModel?.paginationStorageName, this.apiRequestStorageName);
  }

  openAdvanceFilterPopUp() {
    var data = { getAllDropdownModel: this.getAllDropdownModel, agGridDataModel: this.agGridDataModel, apiRequestModel: this.apiRequestModel }
    this.notificationService.openModalPopup(LayawaysReportAdvancedFilterPopupComponent, data, 'Advance Filter').then(
      (resultData) => {
        if (resultData) {
          this.apiRequestModel.filters = JSON.stringify(resultData?.filters);
          this.storageService.store(this.apiRequestStorageName, this.apiRequestModel);
          this.filterCountValue = this.filterCount(resultData);
          this.getAllLayawaysReportList();
        }
      }
    );
  }

  resetFilter() {
    this.apiRequestModel.filters = '';
    this.filterCountValue = 2;
    this.setDefaultFilter();
  }
  fillDropdownData() {
    this.getAllDropdownModel.branchDropdown = this.storageService.retrieve(StorageName.BRANCH_DROPDOWN);
    this.getAllDropdownModel.accountLedgerDropdown = this.storageService.retrieve(StorageName.ACCOUNTLEDGER_DROPDOWN);
    this.getAllDropdownModel.layawaysStatusDropdown = this.storageService.retrieve(StorageName.LAYAWAYS_STATUS_DROPDOWN);
  }

  callApiForExport() {
    const exportAs = this.apiRequestModel?.exportAs;
    this.apiRequestModel.filters = this.apiRequestModel?.filters;
    this.investmentFundService.getAllLayawaysReport(this.apiRequestModel).subscribe({
        next: (res) => {
          this.fileReaderService.exportFile(res, exportAs);
        }, error(error) {
          console.error('Error in downloading Excel/Pdf file:', error);
        },
      }
    );
  }
}
